import React from 'react'
import { ubiznewsEmail, ubiznewsFacebook, ubiznewsInstagram, ubiznewsLinkedIn, ubiznewsYoutube } from '../constants/links'
import { NavLink } from 'react-router-dom'
import { logo, placeholderImg } from '../constants/files'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { getYear } from 'date-fns'
import { contactLink, jobLink } from '../constants/endspoints'

const OffcanvasMenu = () => {

    return (
        <div className="offcanvas offcanvas-end bg-black text-white px-0" id="mobileNav">
            <div className="offcanvas-header bg-black d-flex justify-content-between px-3 py-2 align-items-center">
                <h5 className="offcanvas-title">
                    <NavLink to={'/'}>
                        <LazyLoadImage 
                        src={logo} 
                        alt='ubiznewtv' 
                        style={{height:'2rem'}} 
                        placeholder={<div className=' w-100 h-100'><img src={placeholderImg} className=' h-100 object-fit-contain' alt='' /></div>}
                        effect="black-and-white"
                        height={'2rem'} />
                    </NavLink>
                </h5>
                <span role="button" className="bg-black shadow-none d-flex justify-content-center align-items-center" data-bs-dismiss="offcanvas" aria-label="Close">
                    <i className="fa fa-xmark fs-4 text-white"></i>
                </span>
            </div>
            <div className="offcanvas-body ps-3 pt-0 overflow-x-hidden bg-mobile-footer">
                <div className="h-100 d-flex flex-column">
                    <div className='w-auto'>
                        <div className='row justify-content-between align-items-start mb-3'>
                            <div className=' col-lg-3 col-md-6 col-10 mt-3'>
                                <h4 className='fw-bold'>Services</h4>
                                <NavLink className='text-white d-block pb-1 fs-8s' to={jobLink}>Emplois et stages</NavLink>
                                <NavLink className='text-white d-block pb-1 fs-8s' to={contactLink}>Aide & contact</NavLink>
                            </div>
        
                            <div className=' col-lg-3 col-md-6 col-10 mt-3'>
                                <h4 className='fw-bold'>Infos légales</h4>
                                <NavLink className='text-white d-block pb-1 fs-8s' to=''>Gérer les cookies</NavLink>
                                <NavLink className='text-white d-block pb-1 fs-8s' to=''>Mentions légales et crédits</NavLink>
                                <NavLink className='text-white d-block pb-1 fs-8s' to=''>Conditions générales d’utilisation</NavLink>
                                <NavLink className='text-white d-block pb-1 fs-8s' to=''>Accessibilité</NavLink>
                                <NavLink className='text-white d-block pb-1 fs-8s' to=''>Plan du site</NavLink>
                            </div>
        
                            <div className=' col-lg-3 col-md-6 col-10 mt-3'>
                                <h4 className='fw-bold'>Réseaux sociaux</h4>
                                <a href={ubiznewsFacebook} target='_BLANK' rel='noreferrer' className=' d-flex align-items-center pb-1 text-white'>
                                    <i className='fa-brands fa-facebook-f fs-7s me-2 text-white'></i>
                                    <span className='fs-8s'>Facebook</span>
                                </a>
                                <a href={ubiznewsInstagram} target='_BLANK' rel='noreferrer' className='text-white d-flex align-items-center pb-1'>
                                    <i className='fa-brands text-white fa-instagram fs-7s me-2'></i>
                                    <span className='fs-8s'>Instagram</span>
                                </a>
                                <a href={ubiznewsLinkedIn} target='_BLANK' rel='noreferrer' className='text-white d-flex align-items-center pb-1'>
                                    <i className='text-white fa-brands fa-linkedin-in fs-7s me-2'></i>
                                    <span className='fs-8s'>LinkedIn</span>
                                </a>
                                <a href={ubiznewsYoutube} target='_BLANK' rel='noreferrer' className='text-white d-flex align-items-center pb-1'>
                                    <i className='text-white fa-brands fa-youtube fs-7s me-2'></i>
                                    <span className='fs-8s'>YouTube</span>
                                </a>
                            </div>
        
                            <div className=' col-lg-3 col-md-6 col-10 mt-3'>
                                <h4 className='fw-bold'>Contact</h4>
                                <div className=' row justify-content-around align-items-center gx-1'>
                                    <a href={'mailto:'+ubiznewsEmail} target='_BLANK' rel='noreferrer' className='text-white d-flex align-items-center pb-1'>
                                        <i className='text-white fa fa-envelope fs-7s me-2'></i>
                                        <span className='fs-8s'>{ubiznewsEmail}</span>
                                    </a>
                                </div>
                            </div>
        
                        </div>
                    </div>

                    <div className="text-center mt-auto">
                        <p className='fs-6s text-white fw-medium text-center py-2 mb-0 text-opacity-75'>
                            Tous droits de reproduction et de diffusion réservés © {getYear(Date.now())} UBIZNEWS
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OffcanvasMenu